import { toast } from "react-toastify";
import { getToken } from "../utilities/Constants";
import { getUserInfo } from "./useSession";

export const deleteData = async (api, id, formData) => {
  const apiUrl = id
    ? `${process.env.REACT_APP_API_URL}${api}/${id}`
    : `${process.env.REACT_APP_API_URL}${api}`;
  const requestOptions = {
    method: "DELETE",
    body: formData ? JSON.stringify(formData) : "",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + getToken(),
    },
  };

  // check for admin privilege
  const userRole = await getUserInfo();
  if (userRole.role !== "admin") {
    errorToast("You are not authorized for this action");
    return;
  }

  const response = await fetch(apiUrl, requestOptions)
    .then(async (response) => {
      const isJson = response.headers
        .get("content-type")
        ?.includes("application/json");
      const data = isJson && (await response.json());

      // check for error response
      if (!response.ok) {
        // get error message from body or default to response status
        const error = (data && data.message) || response.status;
        return Promise.reject(error);
      } else {
        toast.info("Data Deleted", {
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        return data;
      }
    })
    .catch((error) => {
      errorToast("Something went wrong!");
    });
  return response;
};

function errorToast(errorMsg) {
  toast.error(errorMsg, {
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });
}
